module.exports = __webpack_public_path__ + "img/07_shimizu_06.06fc052f.jpg";